// extracted by mini-css-extract-plugin
export default {"loading":"styles-module--loading--450ec","loaded":"styles-module--loaded--cc2e6","ended":"styles-module--ended--779b4"};